import { render, staticRenderFns } from "./electric-info.vue?vue&type=template&id=b86dc156&scoped=true&"
import script from "./electric-info.vue?vue&type=script&lang=js&"
export * from "./electric-info.vue?vue&type=script&lang=js&"
import style0 from "./electric-info.vue?vue&type=style&index=0&id=b86dc156&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86dc156",
  null
  
)

export default component.exports